// Строковая работа с датой/временем операции (PERS2-79, PERS2-82).
//
// Сервер отдаёт date как ISO-строку ('2026-08-17T14:35:00.000Z') или
// 'YYYY-MM-DD HH:mm(:ss)' — это уже локальное время сервера. Форматируем
// строково, БЕЗ new Date(...), чтобы в часовых поясах восточнее UTC
// дата/время не «уезжали» на день (таймзоны не вводятся).

const pad = (n) => String(n).padStart(2, '0');

// Дата 'DD.MM.YYYY' из любого входного формата:
// '2026-08-17T14:35:00.000Z' | '2026-08-17 14:35:00' | '2026-08-17T14:35' |
// '2026-08-17 14:35' | date-only '2026-08-17' → '17.08.2026'.
// null/''/undefined → ''.
export const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const datePart = String(dateStr).replace('T', ' ').slice(0, 10);
  const [year, month, day] = datePart.split('-');
  return `${day}.${month}.${year}`;
};

// Время 'HH:mm' из значений с временной частью: '2026-08-17T14:35:00.000Z'
// → '14:35'. Для date-only значений ('2026-08-17') → '' — без фантомного
// «00:00» (PERS2-82 AC-2: вторая строка ленты не рендерится). Реальное
// хранимое время старых операций ('2026-08-16T00:00:00.000Z' / '00:00:00')
// возвращается как '00:00' (PERS2-79 AC-5).
export const formatTime = (dateStr) => {
  if (!dateStr) return '';
  const match = String(dateStr).replace('T', ' ').match(/^\d{4}-\d{2}-\d{2} (\d{2}:\d{2})/);
  return match ? match[1] : '';
};

// Время для ленты операций: полночь ('00:00') трактуется как «время не
// задано» — date-only старые операции (до PERS2-79) хранятся в БД как
// 'YYYY-MM-DD 00:00:00' и не должны показывать фантомную вторую строку
// (PERS2-82 AC-3). Реальное время (14:35 и т.п.) возвращается как есть.
export const formatFeedTime = (dateStr) => {
  const time = formatTime(dateStr);
  return time === '00:00' ? '' : time;
};

// → 'YYYY-MM-DD HH:mm' для value полей даты/времени (без UTC-сдвигов).
// Date-only '2026-08-17' → '2026-08-17 00:00'.
export const toDateTimeLocal = (dateStr) => {
  if (!dateStr) return '';
  const normalized = String(dateStr).replace('T', ' ').slice(0, 16);
  return /^\d{4}-\d{2}-\d{2}$/.test(normalized) ? `${normalized} 00:00` : normalized;
};

// Текущие ЛОКАЛЬНЫЕ дата и время 'YYYY-MM-DD HH:mm' — из
// getFullYear/getMonth/getDate/getHours/getMinutes, НЕ toISOString() (UTC!):
// после полуночи в МСК день не должен «уезжать».
export const localNowDateTime = () => {
  const now = new Date();
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}`;
};
